export interface ValidationResult {
  isValid: boolean;
  errors: Record<string, string>;
}

export function validateRequired(value: string | undefined, fieldName: string): string | null {
  if (!value || value.trim() === "") {
    return `${fieldName} is required`;
  }
  return null;
}

const IDENTIFIER_RE = /^[a-zA-Z_][a-zA-Z0-9_]{0,63}$/;

/** LLM function names must be valid identifiers: letters, digits, underscores;
 * must start with a letter or underscore; max 64 chars. */
export function validateIdentifier(value: string | undefined, fieldName: string): string | null {
  const required = validateRequired(value, fieldName);
  if (required) {
    return required;
  }
  if (!IDENTIFIER_RE.test(value!)) {
    return `${fieldName} must start with a letter or underscore and contain only letters, digits, or underscores (max 64).`;
  }
  return null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function combineValidators<T extends Record<string, any>>(
  values: T,
  validators: { [K in keyof T]?: (value: T[K]) => string | null },
): ValidationResult {
  const errors: Record<string, string> = {};
  let isValid = true;

  for (const [field, validator] of Object.entries(validators)) {
    if (validator) {
      const error = validator(values[field]);
      if (error) {
        errors[field] = error;
        isValid = false;
      }
    }
  }

  return { isValid, errors };
}
